// Add all files that need to be pre-loaded here, e.g. font icons
import MaterialIcons from '@expo/vector-icons/MaterialIcons';

export const sharedCachedFonts = {
  // Font Icons
  ...MaterialIcons.font,
};
